<template functional>
    <div class="detailsSkeleton">
        <div class="skeletonHeading skeletonShort loadEffect skeletonSpacingSmaller"></div>
        <div class="skeletonTitle skeletonShorter loadEffect skeletonSpacingLarge"></div>

        <div class="skeletonTitle skeletonFull loadEffect skeletonSpacingMedium"></div>
        <div class="skeletonTitle skeletonFull loadEffect skeletonSpacingMedium"></div>
        <div class="skeletonTitle skeletonShort loadEffect skeletonSpacingLarge"></div>

        <div class="skeletonDescription skeletonFull loadEffect skeletonSpacingSmall"></div>
        <div class="skeletonDescription skeletonFull loadEffect skeletonSpacingSmall"></div>
        <div class="skeletonDescription skeletonFull loadEffect skeletonSpacingSmall"></div>
        <div class="skeletonDescription skeletonFull loadEffect skeletonSpacingSmall"></div>
        <div class="skeletonDescription skeletonFull loadEffect skeletonSpacingSmall"></div>
        <div class="skeletonDescription skeletonFull loadEffect skeletonSpacingSmall"></div>
        <div class="skeletonDescription skeletonFull loadEffect skeletonSpacingSmall"></div>
        <div class="skeletonDescription skeletonFull loadEffect skeletonSpacingSmall"></div>
        <div class="skeletonDescription skeletonShort loadEffect skeletonSpacingSmall"></div>
    </div>
</template>

<script>
    export default {
        name: 'EntryDetailsSkeleton',
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

    .detailsSkeleton {
        width: 100%;
        max-width: 64rem;
        margin: 4rem 0;
    }

    .skeletonSpacingLarge {
        margin-bottom: 4rem;
    }

    .skeletonSpacingMedium {
        margin-bottom: 2rem;
    }

    .skeletonSpacingSmall {
        margin-bottom: 1.75rem;
    }

    .skeletonSpacingSmaller {
        margin-bottom: 1rem;
    }
</style>